import { runInAction } from 'mobx';

import { ENDPOINTS } from '@/configs/endpoints';
import { TreeNodeFolder } from '@/entities/Tree';
import { notificationsStore } from '@/stores/global/RootStore';
import { MetaStore } from '@/stores/local/shared/MetaStore';
import { PopupStore } from '@/stores/local/shared/PopupStore';
import { TreeStore } from '@/stores/local/shared/TreeStore';
import call from '@/utils/api/api';

type DeleteFolderPopupStoreParams = {
  getOrganizationId: () => number;
  treeStore: TreeStore;
};

export class DeleteFolderPopupStore extends PopupStore<TreeNodeFolder> {
  private readonly _getOrganizationId: () => number;
  private readonly _treeStore: TreeStore;

  readonly meta = new MetaStore();

  constructor({ getOrganizationId, treeStore }: DeleteFolderPopupStoreParams) {
    super();

    this._getOrganizationId = getOrganizationId;
    this._treeStore = treeStore;
  }

  delete = async () => {
    if (!this.entity) {
      return;
    }

    this.meta.setLoadedStartMeta();

    const response = await call({
      endpoint: ENDPOINTS.folder.delete(String(this._getOrganizationId()), String(this.entity.id)),
      method: 'DELETE',
    });

    if (response.isError) {
      notificationsStore.showError(response.error.response?.data.message ?? 'Не удалось удалить папку');
      this.meta.setLoadedErrorMeta();

      return;
    }

    const folderId = String(this.entity.id);

    this._treeStore.removeNode(folderId);

    runInAction(() => {
      this.close();
      this.meta.setLoadedSuccessMeta();
    });
  };

  changeOrganizationId(): void {
    this.close();
    this.meta.reset();
  }

  destroy(): void {
    super.destroy();
    this.meta.destroy();
  }
}
